export class Invoice{
    idInvoice?:string;
    nameProgram:string;
    Fees:number;
    Tax:number;
    Total:number;
    Mount:number;
    dateCreated:number;
    companyId:string;
    companyName:string;
    Currency:string;
    ExpeditionPlace:string;
    PaymentConditions:string;
    Folio:string;
    CfdiType:string;
    PaymentForm:string;
    PaymentMethod:string;
    Receiver?:
        {
            Rfc: string;
            Name: string;
            CfdiUse: string;
        };
    Items?:
        {
            ProductCode: string;
            IdentificationNumber: string;
            Description: string;
            Unit: string;
            UnitCode: string;
            UnitPrice: number;
            Quantity: number;
            Subtotal: number;
            Total: number;
            Taxes?:
                {
                    Total: number;
                    Name: string;
                    Base: number;
                    Rate: number;
                    IsRetention: Boolean;
                }[];
            }[];

    constructor(formData?: any) {
        let data: any = !formData ? {} : formData;
        this.idInvoice = data.idInvoice || null; 
        this.nameProgram=data.nameProgram || null;
        this.Fees = data.Fees || null; ;
        this.Tax = data.Tax || null; 
        this.Total = data.Total || null; 
        this.Mount = data.mount || null;
        this.dateCreated = data.dateCreated || null;
        this.companyId = data.companyId || null;
        this.companyName = data.companyName || null;
        this.Currency = data.Currency || null; 
        this.ExpeditionPlace = data.ExpeditionPlace || null;
        this.PaymentConditions = data.PaymentConditions  || null; 
        this.Folio = data.Folio || null;
        this.CfdiType = data.CfdiType || null;
        this.PaymentForm = data.PaymentForm || null;
        this.PaymentMethod = data.PaymentMethod || null;
        this.Receiver = data.Receiver || {
            Rfc: null,
            Name: null,
            CfdiUse: null
        }
        this.Items = data.Items || {
            ProductCode: null,
            IdentificationNumber: null,
            Description: null,
            Unit: null,
            UnitCode: null,
            UnitPrice: null,
            Quantity: null,
            Subtotal: null,
            Total: null,
            Taxes :  [
                {
                    Total: null,
                    Name: null,
                    Base: null,
                    Rate: null,
                    IsRetention: null
                }
                ]
        }

    }
}